import { getTVL } from "services";
import { useQuery } from "@tanstack/react-query";

type TVLType = {
  value: number;
  usdTvl: number;
  usdPrice: number;
  symbol: string;
  name: string;
};

export type TVLDataType = {
  tvl: TVLType | undefined;
};

const useTVL = () => {
  const { data: tvlData } = useQuery({
    queryKey: ["tvl"],
    queryFn: async () => {
      const r = await await getTVL();
      return r.data;
    },
    refetchInterval: 10_000,
  });

  return {
    tvl: tvlData as TVLType,
  };
};

export default useTVL;
